import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/_services/navigation';

@Component({
  selector: 'app-empty-state',
  templateUrl: './emptystate.component.html',
  styleUrls: ['./emptystate.component.scss']
})
export class EmptystateComponent implements OnInit {
  @Input() title: string = 'Opps';
  @Input() description: string = 'Data tidak ditemukan.';
  @Input() buttonText: string = 'Back';
  @Input() buttonUrl: string = '/dashboard';

  @Output() confirmedClick = new EventEmitter();
  constructor(
    private navigation: NavigationService,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

}